<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col mb-5 mb-md-0">
        <h1 class="text-center py-4">Venta</h1>
        <h3 v-if="buy.claim" class="text-center alert alert-danger">
          <span>Se ha iniciado un reclamo por una de las partes</span>
          <span v-if="claimLoad" class="ml-5 btn btn-success">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Cargando...</span
          >
          <span v-else class="ml-5 btn btn-success" @click="handleSetClaim"
            >Marcar como solucionado</span
          >
        </h3>
        <div class="container">
          <div v-if="buy.claim" class="row">
            <div class="col-md-6 col-12">
              <h3 class="text-center">Datos del vendedor</h3>
              <table class="table">
                <tbody>
                  <tr>
                    <th>Usuario</th>
                    <td>{{ buy.seller.username }}</td>
                  </tr>
                  <tr>
                    <th>Nombre</th>
                    <td>{{ buy.seller.fullName }}</td>
                  </tr>
                  <tr>
                    <th>Dni</th>
                    <td>{{ buy.seller.dni }}</td>
                  </tr>
                  <tr>
                    <th>Teléfono</th>
                    <td>{{ phones.seller }}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{{ buy.seller.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6 col-12">
              <h3 class="text-center">Datos del comprador</h3>
              <table class="table">
                <tbody>
                  <tr>
                    <th>Usuario</th>
                    <td>{{ buy.buyer.username }}</td>
                  </tr>
                  <tr>
                    <th>Nombre</th>
                    <td>{{ buy.buyer.fullName }}</td>
                  </tr>
                  <tr>
                    <th>Dni</th>
                    <td>{{ buy.buyer.dni }}</td>
                  </tr>
                  <tr>
                    <th>Teléfono</th>
                    <td>{{ phones.buyer }}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{{ buy.buyer.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">Comprador</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Codigo</th>
                <th class="d-none d-sm-table-cell" scope="col">Sacoin</th>
                <th class="d-none d-sm-table-cell" scope="col">CRR</th>
                <th class="d-none d-sm-table-cell" scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <td>{{ buy.buyer.username }}</td>
              <td>{{ buy.seller.username }}</td>
              <td>#{{ buy.prettyID }}</td>
              <td class="d-none d-sm-table-cell">
                SC${{ (buy.sacoin + buy.financiamiento + buy.otherPayments.reduce((acc, b) =>  acc + b.sacoin+ b.financiamiento, 0)).toFixed(2) }}
              </td>
              <td class="d-none d-sm-table-cell">
                SC${{ (+buy.crr).toFixed(2) }}
              </td>
              <td class="d-none d-sm-table-cell">
                {{ buy.creationDate.replace(/T/, " ").replace(/\..+/, "") }}
              </td>
            </tbody>
          </table>
          <div class="row mb-5">
            <div class="col-12">
              <h3 class="text-center alert alert-info">Detalles del pago</h3>
              <table class="table">
                <thead class="thead-dark text-center">
                  <tr>
                    <th scope="col">Producto</th>
                    <th class="d-none d-sm-table-cell" scope="col">Cantidad</th>
                    <th class="d-table-cell d-sm-none" scope="col">u</th>
                    <th scope="col">Sacoin</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr v-for="product in buy.products" :key="product._id._id">
                    <td>{{ product._id.name }}</td>
                    <td>{{ product.amount }}</td>
                    <td>SC${{ product.price.toFixed(2) }}</td>
                  </tr>
                  <tr v-for="service in buy.services" :key="service._id._id">
                    <td>{{ service._id.name }}</td>
                    <td>{{ service.amount }}</td>
                    <td>SC${{ service.price.toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>Envío</td>
                    <td>-</td>
                    <td>SC${{ buy.shippingPrice.toFixed(2) }}</td>
                  </tr>
                  <tr v-for="otherPayment in buy.otherPayments" :key="otherPayment.description">
                    <td>{{otherPayment.description}}</td>
                    <td>-</td>
                    <td>SC${{ (otherPayment.sacoin + otherPayment.financiamiento).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>total</td>
                    <td></td>
                    <td>
                      SC${{ (buy.sacoin + buy.financiamiento + buy.otherPayments.reduce((acc, b) =>  acc + b.sacoin+ b.financiamiento, 0)).toFixed(2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12">
                  <h3 class="text-center alert alert-info">
                    Detalles del envío
                  </h3>
                  <table class="table">
                    <thead class="thead-dark text-center">
                      <tr>
                        <th scope="col">tipo de envío</th>
                        <th scope="col">Sacoin</th>
                      </tr>
                    </thead>
                    <tbody class="text-center">
                      <tr>
                        <td>{{ buy.shippingTypeName }}</td>
                        <td>SC${{ buy.shippingPrice.toFixed(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-12">
                  <h3 class="text-center alert alert-info">Estado del envío</h3>
                  <table class="table">
                    <thead class="thead-dark text-center">
                      <tr>
                        <th scope="col">Estado</th>
                        <th scope="col">Fecha</th>
                      </tr>
                    </thead>
                    <tbody class="text-center">
                      <tr>
                        <td>En proceso de aceptación</td>
                        <td>
                          {{
                            buy.creationDate
                              .replace(/T/, " ")
                              .replace(/\..+/, "")
                          }}
                        </td>
                      </tr>
                      <tr v-for="state in buy.state" :key="state._id">
                        <td>
                          <p class="mb-0">{{ state.title }}</p>
                        </td>
                        <td>
                          {{ state.date.replace(/T/, " ").replace(/\..+/, "") }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <h3 class="text-center alert alert-info">Datos del envío</h3>
              <table class="table">
                <tbody class="text-center">
                  <tr v-for="info in buy.shippingInfo" :key="info.key">
                    <td>
                      <b>{{ info.key }}: </b>
                    </td>
                    <td>{{ info.value ? info.value : "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 mb-5">
              <h3 class="text-center alert alert-info">Chat de la venta</h3>
              <div class="chat-container">
                <div
                  v-for="aMessage in chat.messages"
                  :key="aMessage._id"
                  class="item-chat"
                  :class="aMessage.sender ? 'sender' : 'receiver'"
                >
                  <div></div>
                  <div class="chat">
                    <span class="badge badge-pill badge-dark">{{
                      aMessage.creationDate
                        .replace(/T/, " ")
                        .replace(/\..+/, "")
                    }}</span>
                    <b class="pl-2"
                      >{{
                        aMessage.sender
                          ? chat.sender.username
                          : chat.receiver.username
                      }}: </b
                    >{{ aMessage.message }} <span v-show="aMessage.method.amount" class="badge badge-dark">
                      Pedido de {{aMessage.method.currency}}{{aMessage.method.amount}}
                    </span>
                    <span v-show="aMessage.method.amount" :class="aMessage.method.accepted ? 'badge badge-success' : 'badge badge-warning' ">
                      {{aMessage.method.accepted ? 'Pagado' : 'pendiente' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import Api2 from "@/tools/Api2";
import { mapState } from "vuex";

export default {
  name: "AdminPurchase",
  data() {
    return {
      chat: {},
      claimLoad: false,
      phones: {
        buyer: "...",
        seller: "...",
      },
      buy: {
        buyer: { _id: "", username: "", phone: "..." },
        creationDate: "",
        financiamiento: 0,
        products: [],
        sacoin: 0,
        seller: { _id: "", username: "", phone: "..." },
        shippingInfo: [],
        shippingPrice: 0,
        state: [],
        prettyID: 0,
        claim: false,
      },
    };
  },
  computed: {
    ...mapState(["auth", "changes"]),
  },
  methods: {
    handleSetClaim() {
      this.claimLoad = true;
      Api2("buy/claim")
        .patch(this.buy._id, { claim: false })
        .then(() => {
          this.buy.claim = false;
          this.claimLoad = false;
        });
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
  },
  created: function () {
    Api2("buy")
      .get(this.$route.params.id)
      .then((res) => {
        res.buy.shippingTypeName =
          res.buy.shippingType == 0
            ? "Envío acordado con el vendedor"
            : res.buy.shippingType == 1
            ? "Guia prepagada de Sistema Apple"
            : "Recoger en domicilio";

        res.buy.state = res.buy.state.map((state) => {
          switch (state.name) {
            case "IN_PREPARATION":
              return { ...state, title: "En preparación" };
            case "IN_TRAVEL":
              return { ...state, title: `En viaje\n [${state.info}]` };
            case "DELIVERED":
              return { ...state, title: "Entregado" };
            case "CANCEL_BY_SELLER":
              return { ...state, title: "Cancelado por el vendedor" };
            case "PICKUP":
              return { ...state, title: "Entregado" };
            default:
              return { ...state, title: "NOT-FOUND" };
          }
        });
        this.buy = res.buy;

        Api2("chat/buy")
          .get(this.buy._id)
          .then((res) => {
            this.chat = {
              ...res.chat,
              messages: res.messages,
            };
          });

        if (this.buy.claim) {
          Api2("sistem-apple/address")
            .get(this.buy.buyer._id)
            .then((response) => {
              this.phones.buyer = response.telefono;
            });

          Api2("sistem-apple/address")
            .get(this.buy.seller._id)
            .then((response) => {
              this.phones.seller = response.telefono;
            });
        }
      });
  },
};
</script>


<style scoped>
.chat-container {
  overflow-y: auto;
  max-height: 800px !important;
  height: 800px;
}
.item-chat {
  margin-bottom: 1em;
  display: flex;
}
.item-chat.new {
  justify-content: center !important;
  margin: 0 10%;
  border-top: 1px solid grey;
}

.item-chat.new > .chat {
  padding: 0.5em;
}

.item-chat.sender > .chat {
  padding: 0.5em;
  border-radius: 0.3em;
  color: white;
  background-color: #3a567f;
}

.item-chat.receiver > .chat {
  padding: 0.5em;
  background-color: #f1f0f0;
  border-radius: 0.3em;
}
</style>